import { render, staticRenderFns } from "./DistributorDetails.vue?vue&type=template&id=b8780044&scoped=true"
import script from "./DistributorDetails.vue?vue&type=script&lang=js"
export * from "./DistributorDetails.vue?vue&type=script&lang=js"
import style0 from "./DistributorDetails.vue?vue&type=style&index=0&id=b8780044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8780044",
  null
  
)

export default component.exports